import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'

function RelatedItems(props) {
    const getCategory = (category) => {
        sessionStorage.setItem('searchRecipeText', category)
        // props.category(category)
    }
    const [keywords, setKeywords] = useState()    
    const {t}= props

    useEffect(() => {
        console.log('pk:',props)
        setKeywords(props.keywords.split(','))
    },[])

    return (
        <div className="relateditemblk">            
            <h5>{t('ActivityFinder_RelatedKeywords')}</h5>
            <div className="rlinks">
            {
                keywords && keywords.map((keyword, index) => (
                    <a href={'/en/recipe-finder'}>
                        <span key={index} onClick={()=>getCategory(keyword)}>
                        {keyword}
                    </span>
                    </a>
                    
                ))
            }
            </div>
        </div>
    );
}

export default withTranslation()(RelatedItems)